import { ContentfulPageProps } from "../../templates/content-page";
import ArticleHeader from "../article-header";
import { LargeHeader } from "./LargeHeader";
import { LargeHeaderWithImage } from "./LargeHeaderWithImage";
import { SimplePageHeader } from "./SimplePageHeader";

export const PageHeader = ({
  title,
  subTitle,
  headingLayout,
  heroImage,
  author,
  readingTime,
  publishedDate,
  profileImage
}: Omit<ContentfulPageProps, "pageSections">): JSX.Element => {
  if (headingLayout === "No heading") {
    return null;
  }

  switch (headingLayout) {
    case "Simple heading":
      return <SimplePageHeader title={title} />;
    case "Large hero":
      return heroImage ? (
        <LargeHeaderWithImage
          title={title}
          subTitle={subTitle}
          heroImage={heroImage}
        />
      ) : (
        <LargeHeader title={title} subTitle={subTitle} />
      );
    case "Article heading":
        return <ArticleHeader 
          title={title} 
          author={{
          name: author,
          image: profileImage?.url
        }} readingTime={readingTime} publishDate={publishedDate} image={heroImage?.url} />;
  }
};
